// extracted by mini-css-extract-plugin
module.exports = {"root":"_93444fe79c--root--1YUUl","link":"_93444fe79c--link--3MICi"};